import treadmill from '../elements/treadmill.js';
treadmill.register();
